import mapboxgl from "mapbox-gl";
import { useEffect, useRef, useState } from "react";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function MapView({ path }) {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const headingRef = useRef(0);
  const [compassActive, setCompassActive] = useState(false);

  // 🔄 Ambil heading dari kompas HP
  const handleOrientation = (event) => {
    if (event.alpha != null) {
      const heading = 360 - event.alpha;
      headingRef.current = heading;
    }
  };

  // 🧭 Minta izin kompas (untuk iOS Safari)
  const requestCompassPermission = () => {
    if (
      typeof DeviceOrientationEvent !== "undefined" &&
      typeof DeviceOrientationEvent.requestPermission === "function"
    ) {
      DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response === "granted") {
            window.addEventListener(
              "deviceorientation",
              handleOrientation,
              true
            );
            setCompassActive(true);
          } else {
            alert("Izin kompas ditolak");
          }
        })
        .catch(console.error);
    } else {
      // Android dan browser modern
      window.addEventListener("deviceorientation", handleOrientation, true);
      setCompassActive(true);
    }
  };

  // 🗺️ Inisialisasi Mapbox map
  useEffect(() => {
    if (!map.current && path.length > 0) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [path[0].lon, path[0].lat],
        zoom: 18,
        pitch: 60,
        bearing: headingRef.current,
        antialias: true,
      });

      // ❌ Kunci interaksi manual
      map.current.scrollZoom.disable();
      map.current.boxZoom.disable();
      map.current.dragRotate.disable();
      map.current.dragPan.disable();
      map.current.keyboard.disable();
      map.current.doubleClickZoom.disable();
      map.current.touchZoomRotate.disable();

      map.current.on("load", () => {
        // 🏢 Bangunan 3D
        map.current.addLayer({
          id: "3d-buildings",
          source: "composite",
          "source-layer": "building",
          filter: ["==", "extrude", "true"],
          type: "fill-extrusion",
          minzoom: 15,
          paint: {
            "fill-extrusion-color": "#aaa",
            "fill-extrusion-height": ["get", "height"],
            "fill-extrusion-base": ["get", "min_height"],
            "fill-extrusion-opacity": 0.6,
          },
        });

        // 🧭 Rute polyline
        map.current.addSource("route", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [],
            },
          },
        });

        map.current.addLayer({
          id: "route-line",
          type: "line",
          source: "route",
          paint: {
            "line-color": "#1E90FF",
            "line-width": 4,
          },
        });
      });
    }
  }, [path]);

  // 🎮 Kamera gimbal-style mengikuti posisi dan arah
  useEffect(() => {
    let interval;

    if (map.current && path.length > 0) {
      interval = setInterval(() => {
        const latest = path[path.length - 1];

        map.current.easeTo({
          center: [latest.lon, latest.lat],
          bearing: headingRef.current,
          pitch: 60,
          duration: 600,
          easing: (t) => t * (2 - t), // easeOutQuad
        });

        // Update polyline
        const coordinates = path.map((p) => [p.lon, p.lat]);
        const geojson = {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates,
          },
        };

        const source = map.current.getSource("route");
        if (source) {
          source.setData(geojson);
        }
      }, 800); // update tiap 800ms
    }

    return () => clearInterval(interval);
  }, [path]);

  return (
    <div className="relative w-full h-full">
      {/* MAP */}
      <div ref={mapContainer} className="w-full h-full" />

      {/* MARKER tetap di tengah layar */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        <img
          src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
          alt="marker"
          className="w-8 h-8 drop-shadow-md"
        />
      </div>

      {/* TOMBOL AKTIFKAN KOMPAS */}
      {!compassActive && (
        <button
          className="absolute top-4 right-4 bg-white text-black px-4 py-2 rounded shadow"
          onClick={requestCompassPermission}
        >
          Aktifkan Kompas
        </button>
      )}
    </div>
  );
}
